var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricboardBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6015_12977)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6015_12977",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H22V22H2V2Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6015_12977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75475 10.2516H13.4808C14.1699 10.2516 14.7482 10.5026 15.2156 11.0048C15.683 11.5069 15.9167 12.1105 15.9167 12.8157C15.9167 13.5208 15.683 14.1258 15.2156 14.6306C14.7482 15.1354 14.1699 15.3878 13.4808 15.3878H7.95831C7.80875 15.3878 7.68108 15.4407 7.57531 15.5464C7.46955 15.6522 7.41667 15.7799 7.41667 15.9294C7.41667 16.079 7.46955 16.2067 7.57531 16.3124C7.68108 16.4182 7.80875 16.4711 7.95831 16.4711H13.4808C14.4637 16.4711 15.296 16.1116 15.9776 15.3926C16.6592 14.6736 17 13.8146 17 12.8157C17 11.8168 16.6592 10.9591 15.9776 10.2428C15.296 9.52644 14.4637 9.16827 13.4808 9.16827H7.75475L9.46792 7.4551C9.58331 7.33972 9.64234 7.21205 9.645 7.0721C9.64767 6.93215 9.58864 6.80181 9.46792 6.68108C9.3472 6.56036 9.2182 6.5 9.08092 6.5C8.94364 6.5 8.81463 6.56036 8.6939 6.68108L6.12981 9.24517C6.06572 9.30928 6.01764 9.38113 5.98558 9.46071C5.95353 9.54031 5.9375 9.62337 5.9375 9.70992C5.9375 9.79646 5.95353 9.87952 5.98558 9.9591C6.01764 10.0387 6.06572 10.1105 6.12981 10.1746L8.6939 12.7388C8.80929 12.8541 8.93348 12.9097 9.06648 12.9054C9.19949 12.9011 9.32636 12.8386 9.44709 12.7179C9.56781 12.5972 9.62817 12.4682 9.62817 12.3309C9.62817 12.1936 9.56781 12.0646 9.44709 11.9439L7.75475 10.2516Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6015_12977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricboardBackWhite);
export default __webpack_public_path__ + "static/media/electricboard-back-white.e7a9e0a00a8cdc2a431fe73638e2bc93.svg";
export { ForwardRef as ReactComponent };